// @flow
import { SIMPLE } from '@localytics/redux-simple-api-middleware/lib/constants';
import { railsApiActionTypes as Types } from '../constants';
import { RAILS_ENDPOINT_PATH } from '../config';

export const getAppGroups = (orgId: number) => (dispatch: Function) =>
  dispatch({
    [SIMPLE]: {
      // FIXME: Pass orgId to endpoint
      endpoint: `${RAILS_ENDPOINT_PATH}settings/app_groups.json`,
      types: [
        Types.APP_GROUPS_REQUEST,
        Types.APP_GROUPS_SUCCESS,
        Types.APP_GROUPS_FAILURE
      ],
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': 'application/json'
      },
      payload: {
        orgId
      }
    }
  });

export const getApps = (orgId: number) => (dispatch: Function) =>
  dispatch({
    [SIMPLE]: {
      endpoint: `${RAILS_ENDPOINT_PATH}localytics_api/app_selector?org_id=${
        orgId
      }`,
      types: [Types.APPS_REQUEST, Types.APPS_SUCCESS, Types.APPS_FAILURE],
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': 'application/json'
      },
      payload: {
        orgId
      }
    }
  });

export const getEventMappings = (orgId: number) => (dispatch: Function) =>
  dispatch({
    [SIMPLE]: {
      // FIXME: Pass orgId to endpoint
      endpoint: `${RAILS_ENDPOINT_PATH}settings/org_events.json`,
      types: [
        Types.EVENT_MAPPINGS_REQUEST,
        Types.EVENT_MAPPINGS_SUCCESS,
        Types.EVENT_MAPPINGS_FAILURE
      ],
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'content-type': 'application/json'
      },
      payload: {
        orgId
      }
    }
  });



// WEBPACK FOOTER //
// ./src/actions/rails-api.js